import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ActualizacionMasivaPrecioYStock from './ActualizacionMasivaPrecioYStock';
import ActualizacionMasivaTipoYEnvio from './ActualizacionMasivaTipoYEnvio';
import CargaMasivaImagenesExcel from './CargaMasivaImagenesExcel';
import { getFrontendFeatureFlag } from '../../../../utilities/frontendConfig';
import PropTypes from 'prop-types';
import './ActualizacionMasivaPublicaciones.css';

const ActualizacionMasivaPublicaciones = ({ idSeller, userType, idUsuario, tipoUsuario }) => {
    const isSeller = userType.isSeller || userType.isSellerAdmin;
    const isAdmin = userType.isCategory || userType.isAdminMod;
    const showActualizacionMasivaWizard = getFrontendFeatureFlag(
        ['publicaciones', 'showActualizacionMasivaWizard'],
        false
    );
    const cardSize = isAdmin ? 'col-12 col-xxl-4' : 'col-12 col-lg-6 col-xxl-4';

    if (tipoUsuario === 6) {
        return null;
    }

    return (
        <div className="container actualizacion-masiva-page">
            <div className="actualizacion-masiva-hero">
                <div>
                    <span className="actualizacion-masiva-kicker">Publicaciones</span>
                    <h1>Actualización masiva</h1>
                    <p className="actualizacion-masiva-lead">
                        Actualizá precios y stock, tipo de publicación y envío, o imágenes usando el Excel oficial.
                        {showActualizacionMasivaWizard
                            ? ' El wizard guiado te lleva paso a paso; abajo mantenemos la carga directa por archivo, igual que antes.'
                            : ' Abajo mantenemos la carga directa por archivo, igual que antes.'}
                    </p>
                </div>
                <div className="actualizacion-masiva-hero-actions">
                    {showActualizacionMasivaWizard && (
                        <Link
                            to="/Publicaciones/ActualizacionMasivaWizard"
                            className="btn btn-danger btn-lg"
                        >
                            Abrir wizard guiado
                        </Link>
                    )}
                    <Link to="/Publicaciones" className="btn btn-outline-secondary">
                        Volver al listado
                    </Link>
                </div>
            </div>

            <div className="actualizacion-masiva-panel">
                <h2 className="actualizacion-masiva-panel-title">Carga directa con Excel</h2>
                <p className="actualizacion-masiva-panel-desc">
                    Descargá el formato con el botón correspondiente en cada bloque, completá el archivo y confirmá la
                    importación. También podés filtrar en Publicaciones, exportar a Excel, editar y volver a subir el
                    mismo esquema.
                </p>

                <div className="row g-4">
                    <div className={cardSize}>
                        <div className="actualizacion-masiva-tile">
                            <ActualizacionMasivaPrecioYStock
                                idSeller={idSeller}
                                userType={userType}
                                idUsuario={idUsuario}
                            />
                        </div>
                    </div>

                    {(isAdmin || isSeller) && (
                        <div className={cardSize}>
                            <div className="actualizacion-masiva-tile">
                                <ActualizacionMasivaTipoYEnvio />
                            </div>
                        </div>
                    )}

                    <div className={cardSize}>
                        <div className="actualizacion-masiva-tile">
                            <CargaMasivaImagenesExcel
                                idSeller={idSeller}
                                userType={userType}
                                idUsuario={idUsuario}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ActualizacionMasivaPublicaciones.propTypes = {
    idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idUsuario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tipoUsuario: PropTypes.number,
    userType: PropTypes.shape({
        isSeller: PropTypes.bool,
        isSellerAdmin: PropTypes.bool,
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool
    })
};

const mapStateToProps = (state) => ({
    idSeller: state.general.idSeller,
    userType: state.general.userType,
    idUsuario: state.general.userId,
    tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps)(ActualizacionMasivaPublicaciones);
